/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mt-tenth[_ngcontent-%COMP%]{margin-top:.1rem}section#filters[_ngcontent-%COMP%]{position:relative;top:-1rem}section#filters[_ngcontent-%COMP%] > #handle[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{border-top-left-radius:0;border-top-right-radius:0}.footer-top-border[_ngcontent-%COMP%]{border-top-style:dotted;border-top-width:.2rem}"];
export { styles as styles };
